import { createAction, props } from '@ngrx/store';
import { TextbausteinId, TextbausteinListResource, TextbausteinResource } from './textbaustein.model';
import { ChangeEntryListResource } from '@schir-int-client/register-change';

export enum TextbausteinAction {
	LOAD_TEXTBAUSTEINE = 'LOAD_TEXTBAUSTEINE',
	LOAD_TEXTBAUSTEINE_SUCCESS = 'LOAD_TEXTBAUSTEINE_SUCCESS',
	UPDATE_TEXTBAUSTEIN = 'UPDATE_TEXTBAUSTEIN',
	UPDATE_TEXTBAUSTEIN_SUCCESS = 'UPDATE_TEXTBAUSTEIN_SUCCESS',
	RESET_EDITED_TEXT = 'RESET_EDITED_TEXT',
}

export const loadTextbausteine = createAction(
	TextbausteinAction.LOAD_TEXTBAUSTEINE,
	props<{ resources: ChangeEntryListResource }>()
);

export const loadTextbausteineSuccess = createAction(
	TextbausteinAction.LOAD_TEXTBAUSTEINE_SUCCESS,
	props<{ payload: TextbausteinListResource }>()
);

export const resetEditedText = createAction(TextbausteinAction.RESET_EDITED_TEXT);

export const updateTextbaustein = createAction(
	TextbausteinAction.UPDATE_TEXTBAUSTEIN,
	props<{ textbausteinId: TextbausteinId; editedText: string }>()
);

export const updateTextbausteinSuccess = createAction(
	TextbausteinAction.UPDATE_TEXTBAUSTEIN_SUCCESS,
	props<{ textbaustein: TextbausteinResource }>()
);
